import request from '@/router/axios'

const urlPrefix = '/sys';
const urlPrefixBizwage = process.env.VUE_APP_BIZ_WAGE_API;

/**
 * 政策库-热门搜索
 * @param data
 */
export function libraryHot(data) {
  return request({
    url: urlPrefix + '/policy/library/hot',
    method: 'post',
    data
  })
}

/**
 * 政策字典-搜索历史
 * @param data
 */
export function libraryHistory(data) {
  return request({
    url: urlPrefix + '/policy/library/history',
    method: 'post',
    data
  })
}

/**
 * 政策库-适用范围
 * @param params
 */
export function setIdByItemList(params) {
  return request({
    url: urlPrefixBizwage + '/sys/setIdByItemLists',
    method: 'get',
    params
  })
}

/**
 * 政策库-薪酬政策列表
 * @param data
 */
export function wagePolicyList(data) {
  return request({
    url: urlPrefix + '/policy/library/wagePolicy/list',
    method: 'post',
    data
  })
}

/**
 * 政策库-社保公积金列表
 * @param data
 */
export function reserveFundList(data) {
  return request({
    url: urlPrefix + '/policy/library/reserveFund/list',
    method: 'post',
    data
  })
}

/**
 * 政策速递-热门搜索
 * @param data
 */
export function expressHot(data) {
  return request({
    url: urlPrefix + '/policy/express/hot',
    method: 'post',
    data
  })
}

/**
 * 政策速递-人力资源政策速递/人力资源知识园地
 * @param data
 */
export function humanResourcesList(data) {
  return request({
    url: urlPrefix + '/policy/express/humanResources/list',
    method: 'post',
    data
  })
}

/**
 * 政策速递-列表查询
 * @param data
 */
export function expressList(data) {
  return request({
    url: urlPrefix + '/policy/express/list',
    method: 'post',
    data
  })
}

/**
 * 政策速递-邮件取消订阅
 * @param data
 */
export function expressCancel(data) {
  return request({
    url: urlPrefix + `/policy/express/cancel`,
    method: 'post',
    data
  })
}

/**
 * 政策速递-历史搜索查询
 * @param data
 */
export function expressHistory() {
  return request({
    url: urlPrefix + '/policy/express/history',
    method: 'post'
  })
}

/**
 * 政策速递-清空搜索历史
 * @param data
 */
export function expressHistoryDel() {
  return request({
    url: urlPrefix + '/policy/express/history/del',
    method: 'post'
  })
}

/**
 * 政策速递-标记是否已读
 * @param data
 */
export function expressRead(data) {
  return request({
    url: urlPrefix + `/policy/express/read/${ data.id }`,
    method: 'get'
  })
}

/**
 * 行业报告-列表查询
 * @param data
 */
export function reportFuzzy(data) {
  return request({
    url: urlPrefix + '/industry/report/fuzzy',
    method: 'post',
    data
  })
}

/**
 * 行业报告-报告详情
 * @param data
 */
export function reportDetail(data) {
  return request({
    url: urlPrefix + `/industry/report/detail/${ data.id }`,
    method: 'get'
  })
}

/**
 * 政策速递-行业报告阅读次数+1
 * @param data
 */
export function reportIncrease(params) {
  return request({
    url: urlPrefix + '/industry/report/increase',
    method: 'get',
    params
  })
}

/**
 * 业务模板-文档模板
 * @param data
 */
export function businessDocuments(data) {
  return request({
    url: urlPrefix + '/policy/business/documents',
    method: 'post',
    data
  })
}

/**
 * 业务模板-办事指南
 * @param data
 */
export function businessList(data) {
  return request({
    url: urlPrefix + '/policy/business/list',
    method: 'post',
    data
  })
}
